module.exports = __webpack_public_path__ + "img/update-bg.affdc511.svg";